(function () {
    'use strict';

    // When $compileProvider.debugInfoEnabled(false) is called it disables the jquery extension for scope.
    // This is my fix

    angular
        .module(app.modules.common.name)
        .decorator('$compile', compileDecorator);

    compileDecorator.$inject = ['$delegate'];
    function compileDecorator($delegate) {
        if ($delegate.$$addScopeInfo === angular.noop)
            $delegate.$$addScopeInfo = $$addScopeInfo;
        return $delegate;

        function $$addScopeInfo($element, scope, isolated, noTemplate) {
            var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
            $element.data(dataName, scope);
        }
    }
})();